import React, { useState } from "react";
import { ChevronDown, ChevronUp, BookOpenCheck } from "lucide-react";

const SECTIONS = [
  {
    title: "Plain-English Summary",
    body: "What the bill appears to do, in normal language. Start here.",
  },
  {
    title: "Hidden Cost / Future Fee Watch",
    body: "Buried fees, funds, future guidance, agency authority, exemptions, penalties, contributions, and other cost mechanisms. If anything material was found, it shows up here regardless of how the bill is marketed.",
  },
  {
    title: "Public Claim Reality Check",
    body: "Paste a claim from a politician, mailer, news article, social-media post, or advocacy group. Measure X-Ray classifies it against the bill text — supported, contradicted, an outside estimate tied to a real mechanism, plausible, misleading, unsupported, or unable to verify.",
  },
  {
    title: "Changes to Current Law",
    body: "Which California code sections the bill adds, amends, or repeals — with side-by-side current vs. proposed language.",
  },
  {
    title: "Who Gains Power / Who Pays",
    body: "Who gets new authority and who bears the cost or burden.",
  },
  {
    title: "Conflicts & Linkages",
    body: "Where this bill collides with or depends on other measures.",
  },
  {
    title: "Money & Influence",
    body: "Reported FPPC contributions tied to support/oppose committees.",
  },
  {
    title: "Citations / Quote Cards",
    body: "Every quote shows the official source, bill version, page number when available, section, and code reference. Click any quote to see the surrounding paragraph and verify it yourself.",
  },
];

export default function HowToReadReport() {
  const [open, setOpen] = useState(false);
  return (
    <section
      className="paper-card rounded-sm mb-5 overflow-hidden"
      data-testid="how-to-read-report"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 sm:px-5 py-3 text-left hover:bg-[hsl(var(--paper-2))]"
        data-testid="how-to-read-toggle"
      >
        <BookOpenCheck className="w-4 h-4 text-[hsl(var(--ink))]" />
        <span className="section-label">How to read this report</span>
        <span className="ml-auto text-[hsl(var(--ink-muted))]">
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </span>
      </button>
      {open && (
        <div className="px-4 sm:px-5 pb-4 pt-1 border-t border-dashed border-[hsl(var(--rule))]">
          <p className="text-sm text-[hsl(var(--ink-2))] leading-relaxed mb-3 max-w-3xl">
            Start with the plain-English summary, then check Hidden Cost / Future
            Fee Watch for buried money or authority changes. Use Public Claim
            Reality Check to test claims from politicians, media, social media,
            or campaign ads. Always use the citation cards to verify exact bill
            language. Measure X-Ray does not tell you how to vote — it shows
            you what is actually in the text.
          </p>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {SECTIONS.map((s, i) => (
              <div key={i} className="border border-[hsl(var(--rule))] rounded-sm p-3 bg-white">
                <dt className="text-xs font-mono uppercase tracking-wider text-[hsl(var(--ink-muted))] mb-1">
                  {s.title}
                </dt>
                <dd className="text-sm text-[hsl(var(--ink-2))] leading-snug">
                  {s.body}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </section>
  );
}
